import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AuthGuard } from './core/guards/auth/auth.guard';

export const inheritedIraRoutes: Routes = [
  {
    path: 'inherited-ira',
    children: [
      {
        path: '',
        redirectTo: 'triage',
        pathMatch: 'full',
      },
      {
        path: 'triage',
        loadChildren: () =>
          import('./public/inherited-ira-triage/inherited-ira-triage.module').then(
            (m) => m.InheritedIRATriageModule,
          ),
      },
    ],
  },
  {
    path: 'secure/inherited-ira',
    canActivate: [AuthGuard],
    children: [
      {
        path: 'decedent-info',
        loadChildren: () =>
          import('./secure/inherited-ira-decedent-info/inherited-ira-decedent-info.module').then(
            (m) => m.InheritedIraDecedentInfoModule,
          ),
      },
      {
        path: 'personal-info',
        loadChildren: () =>
          import('./secure/personal-info/personal-info.module').then((m) => m.PersonalInfoModule),
      },
      {
        path: 'contact-info',
        loadChildren: () =>
          import('./secure/contact-info/contact-info.module').then((m) => m.ContactInfoModule),
      },
      {
        path: 'settlement-fund',
        loadChildren: () =>
          import('./secure/settlement-fund/settlement-fund.module').then(
            (m) => m.SettlementFundModule,
          ),
      },
      {
        path: 'employment',
        loadChildren: () =>
          import('./secure/employment/employment.module').then((m) => m.EmploymentModule),
      },
      {
        path: 'upload',
        loadChildren: () =>
          import('./secure/document-upload/document-upload.module').then(
            (m) => m.DocumentUploadModule,
          ),
      },
      {
        path: '',
        loadChildren: () =>
          import('./secure/client-due-diligence/client-due-diligence.module').then(
            (m) => m.ClientDueDiligenceModule,
          ),
      },
      {
        path: 'terms',
        loadChildren: () => import('./secure/terms/terms.module').then((m) => m.TermsModule),
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(inheritedIraRoutes)],
  exports: [RouterModule],
})
export class InheritedIraRoutingModule {}
